import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const steps = [{
  num: '1',
  titleKey: 'how.s1.title',
  descKey: 'how.s1.desc'
}, {
  num: '2',
  titleKey: 'how.s2.title',
  descKey: 'how.s2.desc'
}, {
  num: '3',
  titleKey: 'how.s3.title',
  descKey: 'how.s3.desc'
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-navy-900 py-20 sm:py-24" data-id="element-166" data-mp="qiv1kzgdh5vy">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-167" data-mp="cshvl2n1k199">
        <Reveal data-id="element-168" data-mp="cq5eerp3xux9">
          <SectionHeading eyebrow={t('how.eyebrow')} title={t('how.title')} tone="light" data-id="element-169" data-mp="gtjrpalnvx70" />
        </Reveal>

        <ol className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-8" data-id="element-170" data-mp="14je3rpy5phq7">
          {steps.map((step, index) => <Reveal key={step.num} as="li" delay={index * 0.08} data-id="element-171" data-mp="19aw7umvh7yfe" data-mpi={index}>
              <div className="flex h-full gap-5 lg:flex-col lg:gap-0" data-id="element-172" data-mp="2rlo0zlrmz323">
                <div className="flex flex-col items-center lg:flex-row lg:items-center lg:gap-4" data-id="element-173" data-mp="2rjl9syeqz3vs">
                  <span className="font-display text-5xl font-black leading-none text-amber-600 lg:text-6xl" data-id="element-174" data-mp="2mki3zbqy0tmr">
                    {step.num}
                  </span>
                  <span className="mt-3 w-px flex-1 bg-white/15 lg:mt-0 lg:h-px lg:w-full lg:flex-1" aria-hidden="true" data-id="element-175" data-mp="2wjppim7tzuky" />
                </div>
                <div className="lg:mt-6" data-id="element-176" data-mp="369siwniv7ajt">
                  <h3 className="font-display text-lg font-extrabold leading-snug text-white sm:text-xl" data-id="element-177" data-mp="36cwtc2mxb2ix">
                    {t(step.titleKey)}
                  </h3>
                  <p className="mt-2.5 max-w-md text-[15px] leading-relaxed text-white/70" data-id="element-178" data-mp="3fbs29mhcqqpx">
                    {t(step.descKey)}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </ol>

        <Reveal delay={0.1} data-id="element-179" data-mp="3kzgvh8j37hur">
          <div className="mt-14 flex flex-col gap-3 border-t border-white/15 pt-8 sm:flex-row sm:items-center" data-id="element-180" data-mp="3l08smnsc1nn5">
            <a href={BUSINESS.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-md bg-amber-600 px-6 py-3.5 font-display text-sm font-bold text-white transition-[background-color,transform] duration-150 ease-smooth hover:bg-amber-700 active:scale-[0.98]" data-id="element-181" data-mp="3pzlcr0rtkgm1">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-182" data-mp="7sovjl8h0s68" />
              {BUSINESS.phoneDisplay}
            </a>
            <a href={BUSINESS.whatsappHref} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-md border border-white/25 px-6 py-3.5 font-display text-sm font-bold text-white transition-colors duration-150 ease-smooth hover:bg-white/10" data-id="element-183" data-mp="cpp2rzh240yx">
              <MessageCircleIcon className="h-4 w-4 text-whats-500" aria-hidden="true" data-id="element-184" data-mp="vjb55gy4ikic" />
              WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}